import WorkroomModule from './workroom.module'

export default WorkroomModule
